<div class="changelog-container">
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12 text-center">
      <app-alert [titulo]="'Soporte técnico funcional'"></app-alert>
    </div>
  </div>

  <!-- Spinner de carga -->
  <div *ngIf="loading" class="text-center my-5">
    <mat-spinner></mat-spinner>
    <p class="mt-3">Cargando registros...</p>
  </div>

  <!-- Contenedor principal con split panel -->
  <div class="row" *ngIf="!loading">
    <!-- Panel izquierdo - Lista de períodos -->
    <div class="col-md-4 col-lg-3">
      <div class="dates-panel">
        <div class="panel-header">
          <h3>
            <mat-icon>calendar_today</mat-icon>
            Períodos
          </h3>
        </div>

        <div class="dates-list">
          <div
            *ngFor="let entry of paginatedEntries; trackBy: trackById"
            class="date-item"
            [class.selected]="isSelectedEntry(entry)"
            (click)="selectEntry(entry)">

            <div class="date-info">
              <span class="period-text">{{ entry.periodo }}</span>
            </div>

            <mat-icon class="chevron-icon">chevron_right</mat-icon>
          </div>

          <!-- Mensaje si no hay entradas -->
          <div *ngIf="changelogEntries.length === 0" class="no-entries">
            <mat-icon>info</mat-icon>
            <p>No hay registros de soporte.</p>
          </div>
        </div>

        <!-- Controles de paginación -->
        <div class="pagination-controls" *ngIf="changelogEntries.length > 0">
          <button
            mat-icon-button
            (click)="previousPage()"
            [disabled]="!hasPreviousPage"
            matTooltip="Página anterior">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <span class="page-info">
            Página {{ currentPage }} de {{ totalPages }}
          </span>

          <button
            mat-icon-button
            (click)="nextPage()"
            [disabled]="!hasNextPage"
            matTooltip="Página siguiente">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Panel derecho - Detalle de cambios -->
    <div class="col-md-8 col-lg-9">
      <div class="details-panel">

        <!-- Header del detalle -->
        <div class="details-header" *ngIf="selectedEntry">
          <div class="header-content">
            <div class="header-left">
              <mat-icon class="header-icon">description</mat-icon>
              <div>
                <h2>{{ selectedEntry.periodo }}</h2>
              </div>
            </div>
          </div>
        </div>

        <!-- Contenido del log -->
        <div class="log-content">
          <div *ngIf="selectedEntry; else noSelection">

            <div class="log-section">
              <h3>
                <mat-icon>list</mat-icon>
                Tareas Realizadas
              </h3>

              <!-- Contenido HTML sanitizado -->
              <div class="log-html-content" [innerHTML]="selectedEntry.cambiosHtml"></div>
            </div>

          </div>

          <!-- Placeholder cuando no hay selección -->
          <ng-template #noSelection>
            <div class="no-selection-placeholder">
              <mat-icon>touch_app</mat-icon>
              <h3>Seleccioná un período</h3>
              <p>Hacé clic en un período de la lista izquierda para ver las tareas realizadas.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
